export type FormResult<T, E extends Error | undefined> =
  | { ok: true; value: T }
  | { ok: false; error: E | undefined }
  | { ok: undefined; value: T }

export const FormSuccess = <T>(data: T): FormResult<T, never> => {
  return { ok: true, value: data }
}

export const FormError = <E extends Error>(error?: E): FormResult<never, E> => {
  return { ok: false, error }
}

// this is a workaround because of time constraints
export const FormUpdateResult = <T>(data: T): FormResult<T, never> => {
  return { ok: undefined, value: data }
}
